<div style="padding: 5px 5px 5px 5px" *ngIf="auth.isAuthenticated$ | async; else account">
  <div style="padding: 5px">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #account>
  <app-account></app-account>
</ng-template>
